export const WellBeingRoute = "WellbeingRoute";
export const MentialHealthRoute = "MentialHealthRoute";
export const ProfileStackRoute = "ProfileStackRoute";
export const WalletStackRoute = "WalletStackRoute";
export const ChatStackRoute = "Chat";
export const WelcomeRoute = "WelcomeRoute";
export const LogoutRoute = "LogoutRoute";
export const MoreOptionsRoute = "MoreOptionsRoute";
